/**Espacio que permite definir las directivas personalizadas del proyecto,
 * modificiación del comportamiento de los elementos con acceso a bajo nivel del DOM
 */

 /**Definicion de la directiva de seguridad */
export const hasRole = {

	/**Metodo que se dispara en el momento que el elmento se ha insertado en el nodo anfitrion */
	inserted(el, binding, vnode) {
		try {
			let mapData = binding.value || [];
			let context = vnode.context;
			let permisos = vnode.context.$store.state.Session.permission;
			
			let authorities = permisos || [];
			switch (Object.prototype.toString.call(mapData)) {
				case '[object String]':
				case '[object Number]':
					var regExp = new RegExp(`^${mapData.toString()}`, 'g');
					if (!context._.find(authorities, (authority) => regExp.test(authority))) {
						el.remove();
					}
					break;
				case '[object Array]':
					if (context._.intersection(authorities, context._.chain(mapData).map(data => data.toString()).value()).length === 0) {
						el.remove();
					}
					break;
				case '[object Boolean]':
					if (!mapData) {
						el.remove();
					}
					break;
				default:
					el.remove();
			}
		}catch(ex) {
			el.remove();
		}	
	}
}



	